// import { useState, useEffect } from "react";
// import api from "../api/axiosInstance";

// const VideoGallery = () => {
//   const [galleryVideos, setGalleryVideos] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // ✅ Fetch videos from backend
//   useEffect(() => {
//     const fetchVideos = async () => {
//       try {
//         const res = await api.get("/media/get/all", {
//           params: { type: "VIDEO_GALLERY" },
//         });
//         setGalleryVideos(res.data.map((item) => item.url));
//       } catch (err) {
//         console.error("Error fetching videos:", err);
//       }
//     };
//     fetchVideos();
//   }, []);

//   const openLightbox = (index) => {
//     setSelectedVideo(galleryVideos[index]);
//     setCurrentIndex(index);
//   };

//   const closeLightbox = () => setSelectedVideo(null);

//   const navigateVideo = (direction) => {
//     let newIndex;
//     if (direction === "prev") {
//       newIndex =
//         (currentIndex - 1 + galleryVideos.length) % galleryVideos.length;
//     } else {
//       newIndex = (currentIndex + 1) % galleryVideos.length;
//     }
//     setCurrentIndex(newIndex);
//     setSelectedVideo(galleryVideos[newIndex]);
//   };

//   return (
//     <section className="py-16 px-4 md:px-20 bg-white">
//       <h2 className="text-3xl font-bold text-center mb-12 uppercase">
//         RGCC Video Gallery
//       </h2>

//       {/* ✅ Grid stays same */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//         {galleryVideos.map((videoUrl, index) => (
//           <div
//             key={index}
//             className="relative group cursor-pointer"
//             onClick={() => openLightbox(index)}
//           >
//             <video
//               src={videoUrl}
//               muted
//               loop
//               playsInline
//               className="w-full rounded-lg object-cover transition-transform duration-500 group-hover:scale-105"
//             />
//             <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 group-hover:bg-opacity-40 transition-all duration-300 rounded-lg">
//               <svg
//                 className="w-16 h-16 text-white opacity-90"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M14.752 11.168l-6.518-3.758A1 1 0 007 8.242v7.516a1 1 0 001.234.97l6.518-3.758a1 1 0 000-1.742z"
//                 />
//               </svg>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* ✅ Lightbox same */}
//       {selectedVideo && (
//         <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
//           <button
//             onClick={closeLightbox}
//             className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &times;
//           </button>

//           <button
//             onClick={() => navigateVideo("prev")}
//             className="absolute left-4 md:left-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10094;
//           </button>

//           <div className="max-w-4xl w-full">
//             <video
//               src={selectedVideo}
//               controls
//               autoPlay
//               className="w-full max-h-[80vh] object-contain rounded-md"
//             />
//           </div>

//           <button
//             onClick={() => navigateVideo("next")}
//             className="absolute right-4 md:right-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10095;
//           </button>

//           <div className="absolute bottom-4 text-white select-none">
//             {currentIndex + 1} / {galleryVideos.length}
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default VideoGallery;

import { useState, useEffect, useRef } from "react";
import {
  Play,
  Pause,
  Volume2,
  VolumeX,
  ChevronLeft,
  ChevronRight,
  X,
  VideoIcon,
  Film,
  Clock,
  Sparkles,
  Grid3x3,
  Filter,
  Maximize2,
} from "lucide-react";
import api from "../api/axiosInstance";

const VideoGallery = () => {
  const [galleryVideos, setGalleryVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const [filter, setFilter] = useState("all");
  const [viewMode, setViewMode] = useState("grid");

  // Fetch videos from backend
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await api.get("/media/get/all", {
          params: { type: "VIDEO_GALLERY" },
        });
        setGalleryVideos(
          res.data.map((item) => ({
            url: item.url,
            category: item.category || "general",
            title: item.title || `Video ${res.data.indexOf(item) + 1}`,
            duration: item.duration || "00:30",
            thumbnail: item.thumbnail || item.url,
          }))
        );
      } catch (err) {
        console.error("Error fetching videos:", err);
      }
    };
    fetchVideos();
  }, []);

  const videoRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  // Extract unique categories
  const categories = [
    "all",
    ...new Set(galleryVideos.map((video) => video.category)),
  ];

  // Filter videos
  const filteredVideos =
    filter === "all"
      ? galleryVideos
      : galleryVideos.filter((video) => video.category === filter);

  const openLightbox = (index) => {
    setSelectedVideo(filteredVideos[index]);
    setCurrentIndex(index);
    setIsPlaying(true);
  };

  const closeLightbox = () => {
    setSelectedVideo(null);
    setIsPlaying(false);
  };

  const navigateVideo = (direction) => {
    let newIndex;
    if (direction === "prev") {
      newIndex =
        (currentIndex - 1 + filteredVideos.length) % filteredVideos.length;
    } else {
      newIndex = (currentIndex + 1) % filteredVideos.length;
    }
    setCurrentIndex(newIndex);
    setSelectedVideo(filteredVideos[newIndex]);
    setIsPlaying(true);
  };

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
    const videoElement = document.querySelector("#lightbox-video");
    if (videoElement) {
      if (isPlaying) {
        videoElement.pause();
      } else {
        videoElement.play();
      }
    }
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
    const videoElement = document.querySelector("#lightbox-video");
    if (videoElement) {
      videoElement.muted = !isMuted;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-blue-900 via-indigo-800 to-purple-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-blue-300/20 to-purple-300/20 backdrop-blur-sm border-2 border-blue-300/30 flex items-center justify-center shadow-2xl">
                <Film className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            RGCC in{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Motion</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-blue-400 to-purple-400 -rotate-1"></span> */}
            </span>
          </h1>

          <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
            Experience the excitement, beauty, and action of Rangpur Golf &
            Country Club through our video collection
          </p>

          <div className="flex items-center justify-center gap-6">
            {/* <div className="flex items-center gap-2 text-blue-200">
              <Sparkles className="w-5 h-5" />
              <span>High-Quality Videos</span>
            </div>
            <div className="w-1 h-1 bg-blue-300 rounded-full"></div> */}
            <div className="flex items-center gap-2 text-blue-200">
              <Grid3x3 className="w-5 h-5" />
              <span>{galleryVideos.length}+ Videos</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        {/* Filters and Controls */}
        <div
          ref={videoRef}
          className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 mb-8 border border-blue-100"
        >
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
            {/* Filter Buttons */}
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setFilter(category)}
                  className={`px-5 py-2.5 rounded-xl font-medium transition-all duration-300 ${
                    filter === category
                      ? "bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </button>
              ))}
            </div>

            {/* View Toggle */}
            <div className="flex items-center gap-4">
              <div className="flex border-2 border-gray-200 rounded-xl overflow-hidden">
                <button
                  onClick={() => setViewMode("grid")}
                  className={`p-3 ${
                    viewMode === "grid"
                      ? "bg-blue-50 text-blue-600"
                      : "bg-white text-gray-600"
                  }`}
                >
                  <Grid3x3 className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setViewMode("masonry")}
                  className={`p-3 ${
                    viewMode === "masonry"
                      ? "bg-blue-50 text-blue-600"
                      : "bg-white text-gray-600"
                  }`}
                >
                  <Maximize2 className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="mt-6 pt-6 border-t border-gray-100">
            <div className="flex items-center gap-6 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <Filter className="w-4 h-4" />
                <span>
                  Filter: <strong className="text-blue-600">{filter}</strong>
                </span>
              </div>
              <div className="w-px h-4 bg-gray-200"></div>
              <div className="flex items-center gap-2">
                <VideoIcon className="w-4 h-4" />
                <span>
                  <strong className="text-blue-600">
                    {filteredVideos.length}
                  </strong>{" "}
                  videos
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Video Grid */}
        <div
          className={`${
            viewMode === "grid"
              ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6"
              : "columns-1 sm:columns-2 md:columns-3 gap-6"
          }`}
        >
          {filteredVideos.map((video, index) => (
            <div
              key={index}
              className={`relative group cursor-pointer mb-6 ${
                viewMode === "masonry" ? "break-inside-avoid" : ""
              }`}
              onClick={() => openLightbox(index)}
            >
              <div className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 group-hover:scale-[1.02]">
                {/* Video Thumbnail */}
                <div className="relative w-full h-64 bg-gray-900">
                  <video
                    src={video.url}
                    muted
                    playsInline
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-transparent to-transparent"></div>

                  {/* Play Button Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Play className="w-8 h-8 text-white fill-current" />
                    </div>
                  </div>

                  {/* Duration Badge */}
                  <div className="absolute bottom-4 right-4 px-3 py-1 bg-black/60 backdrop-blur-sm rounded-full text-white text-sm">
                    {video.duration}
                  </div>
                </div>

                {/* Video Info */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="font-bold text-lg mb-1 line-clamp-1">
                        {video.title}
                      </h3>
                      <p className="text-sm text-blue-200">
                        {video.category.toUpperCase()}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Category Badge */}
                <div className="absolute top-4 left-4">
                  <div className="px-3 py-1 bg-blue-500/80 backdrop-blur-sm rounded-full text-white text-sm font-semibold">
                    {video.category}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredVideos.length === 0 && (
          <div className="text-center py-20">
            <VideoIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-700 mb-2">
              No videos found
            </h3>
            <p className="text-gray-500">Try selecting a different category</p>
          </div>
        )}
      </div>

      {/* Lightbox */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 z-10 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
          >
            <X className="w-6 h-6" />
          </button>

          {/* Navigation Buttons */}
          <button
            onClick={() => navigateVideo("prev")}
            className="absolute left-4 md:left-10 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>

          <button
            onClick={() => navigateVideo("next")}
            className="absolute right-4 md:right-10 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          {/* Video Container */}
          <div className="relative max-w-5xl w-full">
            <video
              id="lightbox-video"
              src={selectedVideo.url}
              controls={false}
              autoPlay={isPlaying}
              muted={isMuted}
              className="w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
            />

            {/* Custom Controls */}
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent text-white rounded-b-lg">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                  <h3 className="text-xl font-bold mb-1">
                    {selectedVideo.title}
                  </h3>
                  <div className="flex items-center gap-4 text-sm text-gray-300">
                    <span className="px-3 py-1 bg-blue-500/20 rounded-full">
                      {selectedVideo.category.toUpperCase()}
                    </span>
                    <span>
                      Video {currentIndex + 1} of {filteredVideos.length}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    onClick={togglePlay}
                    className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-300 flex items-center justify-center"
                  >
                    {isPlaying ? (
                      <Pause className="w-5 h-5" />
                    ) : (
                      <Play className="w-5 h-5" />
                    )}
                  </button>
                  <button
                    onClick={toggleMute}
                    className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-300 flex items-center justify-center"
                  >
                    {isMuted ? (
                      <VolumeX className="w-5 h-5" />
                    ) : (
                      <Volume2 className="w-5 h-5" />
                    )}
                  </button>
                  <button
                    onClick={() => {
                      const videoElement =
                        document.querySelector("#lightbox-video");
                      if (videoElement) {
                        if (videoElement.requestFullscreen) {
                          videoElement.requestFullscreen();
                        }
                      }
                    }}
                    className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors duration-300 flex items-center gap-2"
                  >
                    <Maximize2 className="w-4 h-4" />
                    Fullscreen
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Counter */}
          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white text-sm">
            {currentIndex + 1} / {filteredVideos.length}
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoGallery;
